// src/components/19.js
import React from 'react';

const Componente19 = () => {
  return (
    <div className="component-container">
      <h2>Número de Propósito: 19</h2>
      <p>
        Para una persona nacida el día 19, el número de propósito asociado sería 19.
      </p>
      <p>
        En numerología, el número 19 combina la energía del 1 (liderazgo) y el 9 (humanitarismo). Las personas nacidas en este día están llamadas a liderar con compasión y a hacer una diferencia significativa en el mundo. Su propósito puede incluir:
      </p>
      <ul>
        <li><strong>Guiar con Compasión:</strong> Estas personas tienen el potencial de liderar y guiar a otros con un enfoque compasivo y humanitario.</li>
        <li><strong>Fomentar el Cambio Positivo:</strong> Su propósito puede incluir trabajar para crear un cambio positivo en la sociedad, apoyando causas y movimientos que beneficien a los demás.</li>
        <li><strong>Inspirar a Otros a Servir:</strong> Su ejemplo puede motivar a otros a involucrarse en acciones humanitarias y a contribuir al bienestar colectivo.</li>
        <li><strong>Buscar la Autenticidad:</strong> Tienen un deseo profundo de vivir de manera auténtica y alinear sus acciones con sus valores.</li>
      </ul>

      <h3>Características del Día de Nacimiento: 19</h3>
      <ul>
        <li><strong>Compasivos:</strong> Su naturaleza empática les permite conectarse fácilmente con los demás y entender sus necesidades.</li>
        <li><strong>Idealistas:</strong> Tienen una visión idealista del mundo y buscan formas de materializarla.</li>
        <li><strong>Motivadores:</strong> Su capacidad para inspirar a otros a actuar y a servir es notable.</li>
      </ul>

      <h4>Resumen</h4>
      <p>
        Las personas nacidas el día 19 son líderes compasivos y humanitarios. Su propósito se centra en guiar a otros hacia el cambio positivo y vivir de manera auténtica. Su empatía y visión idealista les permiten inspirar a otros a contribuir al bienestar de la sociedad.
      </p>
    </div>
  );
};

export default Componente19;
